import React from 'react';

type CardElement = 'div' | 'article' | 'li';

interface CardProps extends React.HTMLAttributes<HTMLElement> {
  as?: CardElement;
  /** Adds hover elevation for cards that are clickable as a whole. */
  interactive?: boolean;
  children: React.ReactNode;
}

/** The shared card surface: radius, border, background, and hover elevation. */
const Card: React.FC<CardProps> = ({ as: Element = 'div', interactive = false, className, children, ...rest }) => (
  <Element
    className={['ui-card', interactive && 'ui-card--interactive', className].filter(Boolean).join(' ')}
    {...rest}
  >
    {children}
  </Element>
);

export default Card;
